/* eslint-disable promise/param-names */
import Vue from 'vue'
import axios from 'axios'
import {
  GET_COMPANIES_ERROR,
  GET_COMPANIES_REQUEST,
  GET_COMPANIES_SUCCESS,
  GET_HIERARCHICAL_COMPANIES_ERROR,
  GET_HIERARCHICAL_COMPANIES_REQUEST,
  GET_HIERARCHICAL_COMPANIES_SUCCESS,
  ADD_COMPANY_ERROR,
  ADD_COMPANY_REQUEST,
  ADD_COMPANY_SUCCESS,
  GET_COMPANIES_WITHOUT_MANAGER_REQUEST,
  GET_COMPANIES_WITHOUT_MANAGER_SUCCESS,
  GET_COMPANIES_WITHOUT_MANAGER_ERROR,
  GET_COMPANIES_WITHOUT_SURVEY_REQUEST,
  GET_COMPANIES_WITHOUT_SURVEY_SUCCESS, GET_COMPANIES_WITHOUT_SURVEY_ERROR,
  GET_PERIMETER_STRUCTURE_REQUEST, GET_PERIMETER_STRUCTURE_SUCCESS, GET_PERIMETER_STRUCTURE_ERROR
} from './actiontypes';
import companyApi from '../../_services/api/company';

const state = {
  hierarchicalCompanies: {},
  companies: {},
  status: '',
  structure: false,
  errors: [],
  hasLoadedOnce: false,
};

const getters = {
  companies: state => state.companies,
  hierarchicalCompanies: state => state.hierarchicalCompanies,
  structure: state => state.structure
};

const actions = {
  [GET_PERIMETER_STRUCTURE_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_PERIMETER_STRUCTURE_REQUEST);
      companyApi.getPerimeterStructure()
          .then((response) => {
            if (response.success === true) {
              commit(GET_PERIMETER_STRUCTURE_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(GET_PERIMETER_STRUCTURE_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(GET_PERIMETER_STRUCTURE_ERROR, error);
            reject(error);
          });
    });
  },
  [GET_HIERARCHICAL_COMPANIES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_HIERARCHICAL_COMPANIES_REQUEST);
      companyApi.getHierarchicalCompanies()
          .then((response) => {
            if (response.success === true) {
              commit(GET_HIERARCHICAL_COMPANIES_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(GET_HIERARCHICAL_COMPANIES_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(GET_HIERARCHICAL_COMPANIES_ERROR, error);
            reject(error);
          });
    });
  },
  [GET_COMPANIES_WITHOUT_MANAGER_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_COMPANIES_WITHOUT_MANAGER_REQUEST, payload);
      companyApi.getCompaniesWithoutManager(payload)
          .then((response) => {
            if (response.success === true) {
              commit(GET_COMPANIES_WITHOUT_MANAGER_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(GET_COMPANIES_WITHOUT_MANAGER_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(GET_COMPANIES_WITHOUT_MANAGER_ERROR, error);
            reject(error);
          });
    });
  },
  [GET_COMPANIES_WITHOUT_SURVEY_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_COMPANIES_WITHOUT_SURVEY_REQUEST);
      companyApi.getCompaniesWithoutSurvey(payload)
          .then((response) => {
            if (response.success === true) {
              commit(GET_COMPANIES_WITHOUT_SURVEY_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(GET_COMPANIES_WITHOUT_SURVEY_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(GET_COMPANIES_WITHOUT_SURVEY_ERROR, error);
            reject(error);
          });
    });
  },
  [GET_COMPANIES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_COMPANIES_REQUEST);
      companyApi.getCompanies()
        .then((response) => {
          if (response.success === true) {
            commit(GET_COMPANIES_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(GET_COMPANIES_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(GET_COMPANIES_ERROR, error);
          reject(error);
        });
    });
  },
  [ADD_COMPANY_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADD_COMPANY_REQUEST);
      companyApi.addCompany(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADD_COMPANY_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADD_COMPANY_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADD_COMPANY_ERROR, error);
          reject(error);
        });
    });
  },
};

const mutations = {
  [GET_PERIMETER_STRUCTURE_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_PERIMETER_STRUCTURE_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'structure', response.encoded_string.file);
  },
  [GET_PERIMETER_STRUCTURE_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [GET_HIERARCHICAL_COMPANIES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_HIERARCHICAL_COMPANIES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'hierarchicalCompanies', response.hierarchical_companies);
  },
  [GET_HIERARCHICAL_COMPANIES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [GET_COMPANIES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_COMPANIES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'companies', response.companies);
  },
  [GET_COMPANIES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [GET_COMPANIES_WITHOUT_SURVEY_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_COMPANIES_WITHOUT_SURVEY_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'companies', response.companies);
  },
  [GET_COMPANIES_WITHOUT_SURVEY_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [GET_COMPANIES_WITHOUT_MANAGER_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_COMPANIES_WITHOUT_MANAGER_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'companies', response.companies);
  },
  [GET_COMPANIES_WITHOUT_MANAGER_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADD_COMPANY_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADD_COMPANY_SUCCESS]: (state, response) => {
    state.status = 'success';;
    state.hasLoadedOnce = true;
  },
  [ADD_COMPANY_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    console.log(response);
    Vue.set(state, 'errors', response.error);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
